import CanalDenuncia from './CanalDenuncia';

export default CanalDenuncia;
